import api from './client';

const get = async (path) => (await api.get(path)).data?.data;
const post = async (path, body = {}) => (await api.post(path, body)).data?.data;
const patch = async (path, body = {}) => (await api.patch(path, body)).data?.data;
const put = async (path, body = {}) => (await api.put(path, body)).data?.data;
const del = async (path) => (await api.delete(path)).data?.data;

export const gateway = {
  listRoutes: () => get('/gateway/routes'),
  createRoute: (body) => post('/gateway/routes', body),
  updateRoute: (routeId, body) => patch(`/gateway/routes/${routeId}`, body),
  deleteRoute: (routeId) => del(`/gateway/routes/${routeId}`),
  refreshRoutes: () => post('/gateway/routes/refresh', {}),

  verifySession: (body) => post('/gateway/verify-session', body),
  getCors: () => get('/gateway/security/cors'),
  putCors: (body) => put('/gateway/security/cors', body),
  addWhitelist: (body) => post('/gateway/security/whitelist', body),
  addBlacklist: (body) => post('/gateway/security/blacklist', body),

  getLimits: () => get('/gateway/limits'),
  patchGlobalLimits: (body) => patch('/gateway/limits/global', body),
  patchUserLimits: (userId, body) => patch(`/gateway/limits/user/${userId}`, body),
  patchTierLimits: (tierId, body) => patch(`/gateway/limits/tier/${tierId}`, body),

  getCircuitBreakers: () => get('/gateway/circuit-breakers'),
  resetCircuitBreaker: (serviceId) => post(`/gateway/circuit-breakers/${serviceId}/reset`, {}),
  createTransformer: (body) => post('/gateway/transformers', body),
  dashboardInit: () => get('/gateway/composite/dashboard-init'),
  grpcWeb: (service) => get(`/gateway/grpc-web/${service}`),

  cacheRules: () => get('/gateway/cache/rules'),
  purgeCache: () => post('/gateway/cache/purge', {}),
  purgeCachePath: (path) => post(`/gateway/cache/purge/${path.replace(/^\/+/, '')}`, {}),

  metricsLive: () => get('/gateway/metrics/live'),
  traceById: (traceId) => get(`/gateway/traces/${traceId}`),
  errorLogs: (limit = 100) => get(`/gateway/logs/errors?limit=${limit}`),

  maintenanceOn: (body) => post('/gateway/maintenance/on', body),
  maintenanceOff: () => post('/gateway/maintenance/off', {}),
  canarySetup: (body) => post('/gateway/canary/setup', body),
  canaryAdjust: (body) => patch('/gateway/canary/adjust', body),
  health: () => get('/gateway/health'),
  serviceStatus: () => get('/gateway/status/services')
};
